var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypescriptLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 122.88",
    width: "50px",
    height: "50px",
    style: {
      enableBackground: "new 0 0 122.88 122.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#007ACC;} .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,61.44V0h122.88v122.88H0V61.44L0,61.44z M0,61.44L0,61.44L0,61.44L0,61.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.94,61.65v5.01h15.97v45.47h11.34V66.66h15.97v-4.92c0-2.76,0-5.01-0.12-5.07c0-0.09-9.74-0.12-21.57-0.12 l-21.5,0.09v5.04L26.94,61.65L26.94,61.65L26.94,61.65z M98.73,56.52c3.13,0.74,5.53,2.15,7.68,4.39c1.14,1.23,2.83,3.38,2.95,3.93 c0,0.18-5.31,3.78-8.54,5.78c-0.12,0.09-0.61-0.43-1.11-1.23c-1.6-2.27-3.23-3.26-5.78-3.44c-3.69-0.25-6.14,1.69-6.14,4.91 c0,0.98,0.18,1.54,0.55,2.33c0.83,1.69,2.37,2.7,7.13,4.79c8.79,3.78,12.6,6.27,14.9,9.83c2.61,3.99,3.19,10.26,1.44,14.96 c-1.97,5.13-6.76,8.6-13.61,9.74c-2.15,0.37-7.07,0.31-9.37-0.09c-4.91-0.92-9.62-3.38-12.5-6.54c-1.14-1.23-3.32-4.52-3.19-4.73 l1.17-0.74l4.61-2.67l3.47-2.03l0.8,1.08c1.01,1.6,3.29,3.75,4.61,4.49c3.99,2.06,9.34,1.78,11.98-0.61 c1.14-1.04,1.63-2.15,1.63-3.69c0-1.41-0.22-2.06-0.92-3.13c-0.98-1.35-2.95-2.46-8.48-4.91c-6.36-2.7-9.06-4.42-11.58-7.07 c-1.44-1.6-2.76-4.09-3.38-6.14c-0.46-1.78-0.61-6.14-0.18-7.9c1.32-6.14,5.96-10.44,12.6-11.67c2.15-0.43,7.22-0.25,9.34,0.31 L98.73,56.52L98.73,56.52L98.73,56.52z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescriptLogo);
export default __webpack_public_path__ + "static/media/typescriptLogo.9fb8bf6ecc3c89eb25ce35331c215ce8.svg";
export { ForwardRef as ReactComponent };